// @flow
import React from 'react';
import { Box, Image, Flyout, Mask, Text } from 'gestalt';

type Props = {|
  anchor: ?HTMLElement,
  dismiss: () => void,
  idealDirection: 'up' | 'right' | 'down' | 'left',
  text: string,
  thumbnails: Array<string>,
|};

const IMAGE_HEIGHT = 60;
const IMAGE_WIDTH = 50;
const IMAGE_NATURAL_SIZE = 60;

export default class RichBoardIdeasTooltip extends React.PureComponent<Props> {
  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  onScroll = () => {
    const { dismiss } = this.props;

    if (this.dismissed || this.timer) {
      return;
    }
    this.timer = setTimeout(() => {
      dismiss();
      this.dismissed = true;
      this.timer = undefined;
    }, 3000);
  };

  timer: TimeoutID | void;
  dismissed: boolean = false;

  render() {
    const { anchor, text, thumbnails, idealDirection } = this.props;
    const thumbnailsToDisplay = thumbnails.slice(-3);
    return (
      <Flyout
        anchor={anchor}
        color="white"
        idealDirection={idealDirection}
        onDismiss={this.onScroll}
        shouldFocus={false}
        size="md"
      >
        <Box display="flex" alignContent="center" justifyContent="between" padding={3} width="100%">
          <Box
            alignItems="center"
            display="flex"
            flex="grow"
            justifyContent="center"
            marginStart={-3}
            paddingX={3}
          >
            <Text color="darkGray" size="md" weight="bold">
              {text}
            </Text>
          </Box>
          <Box display="flex" marginEnd={-2} paddingX={2}>
            {thumbnailsToDisplay.map((thumbnail) => (
              <Box key={thumbnail} height={IMAGE_HEIGHT} width={IMAGE_WIDTH} paddingX={1}>
                <Mask shape="rounded" height={IMAGE_HEIGHT}>
                  <Image
                    alt="More Ideas Thumbnail"
                    color="rgb(86, 152, 239)"
                    fit="cover"
                    naturalHeight={IMAGE_NATURAL_SIZE}
                    naturalWidth={IMAGE_NATURAL_SIZE}
                    src={thumbnail}
                  />
                </Mask>
              </Box>
            ))}
          </Box>
        </Box>
      </Flyout>
    );
  }
}
